
export const VERSION ='2.1.1';
export const BIN = new URL('./server.bin', import.meta.url);
